import { createFileRoute } from "@tanstack/react-router"

import { AuditTrail } from "@/features/audit/audit-trail"

export const Route = createFileRoute("/audit")({ component: AuditScreen })

/**
 * Thin on purpose, like `/feedback` and `/imports`: a TanStack route file may
 * export nothing but its `Route`, so anything written in one is untestable by
 * construction and everything worth testing lives in the feature.
 *
 * No role guard here either, and for the same reason those two have none: the
 * screen stays reachable by URL, the navigation entry is gated, and both
 * endpoints refuse anyone they are not for. What the feature does hold is the
 * choice of WHICH endpoint to call, which is not a guard - it is a question the
 * screen cannot avoid answering, and its answer for somebody with neither door
 * is a sentence rather than a request that could only be refused.
 */
function AuditScreen() {
  return <AuditTrail />
}
